"use client"

import { TextButton } from "./TextButton"
import { CopyIcon } from "./icons/CopyIcon"

interface Props {
  url: string
}
export function CopyButton({ url }: Props) {
  return (
    <TextButton
      className="group flex h-40 w-110 min-w-max items-center justify-around space-x-[0.3em] focus:outline-none focus:ring-indigo-400"
      onClick={() => navigator.clipboard.writeText(url)}
    >
      <div className="flex-1">
        <span className="group-focus:hidden">Copy Link</span>
        <span className="hidden group-focus:block">Copied!</span>
      </div>
      <span className="min-w-30 text-gray-700 dark:text-trueGray-400">
        <CopyIcon />
      </span>
    </TextButton>
  )
}
